// ResponseDeadlineBar.jsx — 响应时限的钟点条（SB-190 §8，第二百四十七批，步 5）。
//
// 「截止 2026-09-14 15:00 · 规则 1bd_defer（该日第 4 件）」+ 状态芯片。**一份**渲染，
// 四个读面共用：工单详情头（TicketDetailView，两位当事人看同一条）、站内信列表行、
// 站内信详情头、强读闸的呈现头，外加提交页 201 回执那一眼。四处各画一遍就是四份会漂的
// 副本，而这一条恰是 D4 ① 的证据面——发出方看「他还欠我」、受指派人看「我还欠他」，
// 两边看到的必须是同一个数、同一个词。
//
// 判据全部在 pages/responseSla.mjs 的 deadlineBar（SB-042）：这里只按它给的几位摆字。
// 值域外的 rule / state 印原码、不套标签（替读面说话比印一个奇怪的码更坏）。
//
// 时区：截止时刻按读者本地时区印（fmtTime，与本仓每一处时刻一致）；日历时区的 SOP-11 帧
// （deadlineAt，"…-07:00"）挂在 title 上——合同的帧一悬停就在，正文不印两个时区。
// fmtTime 从纯模块引、**不**从 TicketDetailView.jsx 引：那个文件引本组件，反向再引它就是
// 一个 .jsx 互引环（responseSla.test 钉住）。
import { Chip, Stack, Typography } from '@mui/material';
import { useLang, useT } from '../i18n/index.mjs';
import { deadlineBar } from '../pages/responseSla.mjs';
import { fmtTime } from './fmtTime.mjs';

export default function ResponseDeadlineBar({ deadline, dense = false }) {
  const t = useT();
  const { lang } = useLang();
  const b = deadlineBar(deadline);
  if (!b) return null;
  return (
    <Stack
      direction="row"
      spacing={0.5}
      useFlexGap
      sx={{ alignItems: 'center', flexWrap: 'wrap', mt: dense ? 0.5 : 0 }}
    >
      {/* 逾期（color === 'error'）时正文也走红——一条灰字加一枚红芯片，扫一眼只看得见灰字。 */}
      <Typography
        variant="caption"
        color={b.color === 'error' ? 'error' : 'text.secondary'}
        title={b.dueAt || undefined}
      >
        {t('sla.bar.due', { t: fmtTime(b.dueMs, lang) })}
        {' · '}
        {/* 规则印码（设计原话「规则 1bd_defer」）；句子作 title，值域外的码没有句子。 */}
        <span title={b.ruleKey ? t(b.ruleKey) : undefined}>{t('sla.bar.rule', { rule: b.rule })}</span>
        {t('sla.bar.rank', { n: String(b.rank) })}
      </Typography>
      {b.stateKey ? (
        <Chip size="small" variant="outlined" color={b.color} label={t(b.stateKey)} />
      ) : b.state ? (
        <Typography variant="caption" color="text.secondary">{b.state}</Typography>
      ) : null}
      {b.extended ? (
        <Typography variant="caption" color="text.secondary">
          {t('sla.bar.extended', { t: fmtTime(b.effectiveMs, lang) })}
        </Typography>
      ) : null}
      {b.frozen ? (
        <Typography variant="caption" color="text.secondary">{t('sla.bar.frozen')}</Typography>
      ) : null}
    </Stack>
  );
}
